import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getProd } from '@figure/frontlib-onboarding-redux';
import { Button, Modal, TitleTable, Typography } from '@figure/frontlib-gui';
import {
  usePersonalLoan,
  useRedirect,
  useSiteMaintenanceDownTime,
  usePrevious,
  usePersonalLoanRouteFsm,
} from 'shared/hooks';
import { SiteMaintenanceDownTimePage } from 'shared/components/SiteMaintenanceDownTimePage';
import TimeoutImage from '../assets/images/timeout.svg';
import { PageHeader } from './Typography';

const TimeoutContainer = () => {
  const [isOpen, setOpen] = useState(false);
  const isTest = !getProd();
  const { personalLoan } = usePersonalLoan();
  const { redirectToDashboard } = useRedirect();

  const handleDashboardClick = () => redirectToDashboard();

  const runRouter = usePersonalLoanRouteFsm();
  const { isMaintenanceDownTime } = useSiteMaintenanceDownTime();
  const isMaintenanceDownTimePreviousStatus = usePrevious(isMaintenanceDownTime);
  // Redirect user if on timeout page when maintenance downtime ends
  useEffect(() => {
    if (!isMaintenanceDownTime && isMaintenanceDownTimePreviousStatus) {
      runRouter();
    }
  }, [isMaintenanceDownTimePreviousStatus, isMaintenanceDownTime, runRouter]);

  if (isMaintenanceDownTime) return <SiteMaintenanceDownTimePage />;

  return (
    <>
      <PageHeader>Application In Review</PageHeader>
      <Typography.Body>
        We are in the process of reviewing your application. You can check the status of your
        application on the dashboard.
      </Typography.Body>
      <div className="center" style={{ marginBottom: '2rem', marginTop: '1.6rem' }}>
        <img src={TimeoutImage} alt="" />
      </div>
      <div className="center">
        <Button primary large onClick={handleDashboardClick} semanticElement={Link}>
          Go to dashboard
        </Button>

        {isTest && (
          <Button secondary large onClick={() => setOpen(true)} style={{ marginLeft: '1rem' }}>
            See test errors
          </Button>
        )}
      </div>
      <Modal header="Application Status" size="md" isOpen={isOpen} onClose={() => setOpen(false)}>
        <TitleTable header="Fields">
          <tbody>
            {Object.keys(personalLoan.status || {}).map((k) => (
              <tr key={k}>
                <td>{k}</td>
                <td>{`${personalLoan.status[k]}`}</td>
              </tr>
            ))}
          </tbody>
        </TitleTable>
      </Modal>
    </>
  );
};

export default TimeoutContainer;
